import React, { FC } from 'react';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { default as MuiMenuList } from '@material-ui/core/MenuList';
import { MenuListProps } from './types';
import Fade from '@material-ui/core/Fade';
import { withStyles } from '@material-ui/core/styles';
import paperStyles, { menuListStyles } from './styles';
import { css } from '../customEmotion';

const StyledPaper = withStyles(paperStyles)(Paper);
const StyledMenuList = withStyles(menuListStyles)(MuiMenuList);

const MenuList: FC<MenuListProps> = ({
  open,
  onMenuClose,
  anchorEl,
  placement,
  children,
  modifiers,
  fade = false,
}) => {
  const paper = (
    <StyledPaper>
      <ClickAwayListener onClickAway={onMenuClose}>
        <StyledMenuList>{children}</StyledMenuList>
      </ClickAwayListener>
    </StyledPaper>
  );
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      transition
      modifiers={modifiers}
      className={css`
        z-index: 100;
      `}
    >
      {({ TransitionProps }) => {
        if (fade) {
          return (
            <Fade {...TransitionProps} timeout={400}>
              {paper}
            </Fade>
          );
        } else {
          return paper;
        }
      }}
    </Popper>
  );
};

export default MenuList;
